import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { useGetAdminProfileQuery } from "../store/api/userAPI";
import { setProfile } from "../store/slices/userSlice";
import { useEffect, useRef } from "react";

export const useUser = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state: RootState) => state.user);
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const lastProfileIdRef = useRef<string | null>(null);

  // Get admin profile query
  const {
    data: profileResponse,
    isLoading: isProfileLoading,
    error: profileError,
    refetch: refetchProfile,
  } = useGetAdminProfileQuery(undefined, {
    skip: !isAuthenticated, // Skip if not authenticated
  });

  // Update Redux store when profile data is fetched (only if data changed)
  useEffect(() => {
    if (profileResponse?.data) {
      const newProfile = profileResponse.data;
      // Only update if profile ID is different to prevent unnecessary dispatches
      if (lastProfileIdRef.current !== newProfile._id) {
        lastProfileIdRef.current = newProfile._id;
        dispatch(setProfile(newProfile));
      }
    }
  }, [profileResponse?.data, dispatch]);

  // Safe refetch function that only refetches if query is enabled
  const safeRefetchProfile = () => {
    if (isAuthenticated && refetchProfile) {
      try {
        refetchProfile();
      } catch (error) {
        // Silently handle refetch errors (e.g., query not started yet)
        console.warn("Profile refetch error:", error);
      }
    }
  };

  return {
    // State
    profile,

    // Loading states
    isProfileLoading,

    // Error states
    profileError,

    // Actions
    refetchProfile: safeRefetchProfile,
  };
};

